import {
  CardRequest,
  CardResponse,
} from "./interfaces";
import { request } from "./request";


export async function requestDiscountCardAPI(payload: CardRequest, authToken: string): Promise<CardResponse> {
  const response = await request(
    {
      url: "/discount_card/send",
      method: "POST",
      data: payload,
    },
    authToken,
    "base",
  );

  return response as CardResponse;
}
